import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';

'use strict';

import {ViewChild, Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";

import {ToasterService} from "angular2-toaster";
import {TranslocoService} from '@jsverse/transloco';

import {ActivePromotionConfig} from "../config/active-promotion.config";
import {asOrientDate, DataService, isOrientDate, OrientDBCollectionView} from "@cosbeni/database";
import {Observable} from 'rxjs';

@Component({
    standalone: false,
    selector: 'cj-admin-auction',
    templateUrl: 'auction-management.component.html',
})

export class AuctionManagementComponent implements OnInit {
    readonly: Boolean = true;
    @ViewChild('auctionGrid') auctionGrid: wjcGrid.FlexGrid;
    auctions: OrientDBCollectionView;
    items: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    mode: string = "view";
    auction: any = {};
    destination: any = {};
    optionAuction: any[] = [];
    optionPlace: any[] = [];
    optionStatus: any[] = [];
    optionLane: any[] = [];
    selectAll: Boolean = false;
    counter: number = 1;

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private transloco: TranslocoService) {
        this.auctions = new OrientDBCollectionView(dataService, ActivePromotionConfig.DATABASE, "SELECT FROM DA_Auction", "DA_Auction", "", 0, 100, true, true, false)
        this.auctions.url = ActivePromotionConfig.SERVER_URL;
        this.auctions.tokenName = ActivePromotionConfig.DATABASE + "_token";
        this.auctions.itemsSourceFunction = function (items: any[]) {
            for (let item of items) {
                if (isOrientDate(item.eventDate)) {
                    item.eventDate = asOrientDate(item.eventDate);
                }
            }
            return items;
        }
        this.auctions.preSaveChangesFunction = function (sourceItems) {
            let items = [];
            for (let sourceItem of sourceItems) {
                let item = Object.assign({}, sourceItem);
                if (wjcCore.isDate(sourceItem.eventDate)) {
                    item.eventDate = wjcCore.Globalize.formatDate(sourceItem.eventDate, 'yyyy-MM-dd');
                }
                items.push(item);
            }
            return items;
        }.bind(this);
        this.auctions.sortDescriptions.push(new wjcCore.SortDescription("eventDate", false));
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionPlace = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionPlace.push(item.value);
                }
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='開催状態' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='開催状態' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionStatus = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionStatus.push(item.value);
                }
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            this.optionLane = []
            if (wjcCore.isArray(data.results)) {
                for (let item of data.results) {
                    this.optionLane.push(item.value);
                }
            }
        })
        this.createNew();
        this.loadOptionAuction();
        this.mode = "view";
    }

    ngOnInit() {
        this.auctions.currentChanged.addHandler(this.onCurrentChanged, this);
        this.auctions.filterOnServer = true;
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (this.auctions.currentItem != null) {
            this.auction = Object.assign({}, this.auctions.currentItem);
            this.loadItems();
        }
    }

    loadOptionAuction() {
        this.dataService.query({
            sql: "SELECT FROM DA_Auction ORDER BY eventDate DESC",
            count: "SELECT FROM DA_Auction ORDER BY eventDate DESC",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                for (let auction of data.results) {
                    if (isOrientDate(auction.eventDate)) {
                        auction.eventDate = asOrientDate(auction.eventDate);
                        auction.display = wjcCore.Globalize.formatDate(auction.eventDate, 'yyyy/MM/dd HH:mm:ss') + " " + auction.place + " " + auction.lane;
                    }
                }
                this.optionAuction = data.results;
            }
        })
    }

    loadItems() {
        if (this.auctions.currentItem != null) {
            let where = [];
            where.push("auction = " + this.auctions.currentItem['@rid']);
            this.dataService.query({
                sql: "SELECT FROM DA_Item WHERE " + where.join(" AND "),
                count: "SELECT FROM DA_Item WHERE " + where.join(" AND "),
                fetchPlan: "*:1",
            }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results)) {
                    for (let item of data.results) {
                        if (isOrientDate(item.published)) {
                            item.published = asOrientDate(item.published);
                        }
                    }
                    this.items.trackChanges = true;
                    this.items.sourceCollection = data.results;
                    this.items.refresh();
                }
            })
        }
    }

    onSelectAllChange() {
        if (this.selectAll) {
            for (let item of this.items.items) {
                item.$selected = true;
            }
        } else {
            for (let item of this.items.items) {
                item.$selected = false;
            }
        }
        this.items.refresh();
    }

    createNew(): void {
        this.mode = "edit";
        let today = new Date();
        let eventDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.auction = {
            "@class": "DA_Auction",
            "@rid": "#-1:-1",
            eventDate: eventDate,
            images: [],
            lane: "",
            place: "神戸",
            status: "未開催",
            taxPercentage: 0.1,
            entranceFee: 1000,
        }
    }

    editAuction(): void {
        this.mode = "edit";
        if (this.auctions.currentItem != null) {
            this.auction = Object.assign({}, this.auctions.currentItem);
        }
    }

    cancelAuction(): void {
        this.mode = "view";
        if (this.auctions.currentItem != null) {
            this.auction = Object.assign({}, this.auctions.currentItem);
        }
    }

    saveAuction(): void {
        this.saveAuction$().subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                this.auctions.queryData();
                this.dataService.get({}, ActivePromotionConfig.SERVER_URL + "/rest/auction/reschedule").subscribe(data => {
                    this.toasterService.pop('info', this.transloco.translate('admin.schedule'), this.transloco.translate('admin.auction_scheduled'));
                })
                this.loadOptionAuction();
                this.mode = "view";
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
            }
        )
    }

    saveAuction$(): Observable<any> {
        let auction = Object.assign({}, this.auction);
        if (wjcCore.isDate(auction.eventDate)) {
            auction.eventDate = wjcCore.Globalize.formatDate(auction.eventDate, 'yyyy-MM-dd HH:mm:ss');
        }
        let sql = "BEGIN\n"
        let mapItem: any[] = [];
        Object.entries(auction).forEach(([key, value]) => {
            if (wjcCore.isNumber(value) && !key.startsWith("@")) {
                if (key != "id" && value != 0) {
                    mapItem.push(key + "=" + value)
                }
            } else {
                if (!key.startsWith("@") && value != null) {
                    if (wjcCore.isString(value)) {
                        let v: string = value;
                        v = v.replace(/\\/g, "\\\\");
                        v = v.replace(/\n/g, "\\n");
                        v = v.replace(/\t/g, "\\t");
                        v = v.replace(/'/g, "\\'");
                        v = v.replace(/"/g, '\\"');
                        value = v;
                    }
                    mapItem.push(key + "='" + value + "'")
                }
            }
        });
        if (auction['@rid'] == "#-1:-1") {
            sql = sql + "let header = INSERT INTO DA_Auction SET " + mapItem.join(",") + " return $current\n";
        } else {
            sql = sql + "UPDATE DA_Auction SET " + mapItem.join(",") + " WHERE @rid = " + this.auction['@rid'] + "\n";
        }
        sql = sql + "COMMIT RETRY 100\n";
        return this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL);
    }

    applyCounter() {
        for (let item of this.items.items) {
            if (item.$selected) {
                this.items.editItem(item);
                item.sort = this.counter;
                this.counter = this.counter + 1;
                this.items.commitEdit();
            }
        }
        this.items.refresh();
    }

    applyAuction() {
        for (let item of this.items.items) {
            if (item.$selected) {
                this.items.editItem(item);
                item.auction = this.destination;
                item.auctionResult = "未セリ";
                this.items.commitEdit();
            }
        }
        this.items.refresh();
    }

    saveItem() {
        if (this.items.itemsEdited.length > 0) {
            let sql = "BEGIN\n"
            for (let item of this.items.itemsEdited) {
                sql = sql + "UPDATE DA_Item SET sort = " + item.sort + ",auction = " + item.auction['@rid'] + ",auctionResult = '" + item.auctionResult + "' WHERE @rid = " + item['@rid'] + "\n";
            }
            sql = sql + "COMMIT RETRY 100\n";
            this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                    this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                    this.loadItems();
                },
                (error: any) => {
                    this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
                });
        }
    }

    cancelItem() {
        this.loadItems();
    }

    refresh(grid: string): void {
        this[grid].invalidate();
    }

}

